export default __webpack_public_path__ + "fonts/poppins-latin-600-normal.91145014c0350c248ed2.woff2";